<template>
    <div class="filling-goods-div">
        <van-nav-bar title="计件" left-text="注销" left-arrow right-text="添加副手" @click-left="onClickLeft"
            @click-right="onClickRight" />
        <span style="color: red" v-if="hostcs">测试服</span>
        <!-- 新增按钮 -->

        <!-- <button @click="scanQRCode" class="scan-button" v-if="!showBluetooth" style=" 
        margin-bottom: 10px; 
        font-size: 16px; 
        padding: 10px 20px; 
        background: linear-gradient(90deg, #2196F3, #42A5F5); 
        color: white; 
        border: none; 
        border-radius: 25px; 
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
        cursor: pointer; 
        transition: all 0.3s ease;">
            请点击扫一扫
        </button>
        <button @click="qrcode_scarcn" class="scan-button" v-if="showScanningInput" style="
        margin-bottom: 10px;
        font-size: 16px;
        padding: 10px 20px;
        background: linear-gradient(90deg, #2196F3, #42A5F5);
        color: white;
        border: none;
        border-radius: 25px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;
      ">
            网页扫码
        </button> -->
        <div class="scan-btn-group">
            <button @click="scanQRCode" class="scan-button" v-if="!showBluetooth">
                请点击扫一扫
            </button>

            <button @click="qrcode_scarcn" class="scan-button" v-if="showScanningInput">
                网页扫码
            </button>
        </div>

        <!-- 扫码弹层 -->
        <div v-if="showScanner" class="scanner-mask">
            <div class="scanner-box">
                <h3 style="margin: 0 0 10px;">请将二维码放入框内</h3>

                <div id="qr-reader" style="width: 320px; max-width: 80vw; margin: 0 auto;"></div>

                <div style="margin-top: 12px; display: flex; gap: 8px; justify-content: center;">
                    <button @click="switchCamera" :disabled="cameras.length < 2">
                        切换摄像头
                    </button>
                    <button @click="stopScanner">关闭扫码</button>
                </div>

                <p style="margin-top: 10px; font-size: 12px; color: #666;">
                    当前摄像头：{{ currentCameraLabel || "未知" }}
                </p>
            </div>
        </div>



        <!-- Bluetooth Section -->
        <!-- <div v-if="showBluetooth" class="bluetooth">
            <div style="font-size: 14px;">请扫描工号: </div>
            <input id="bluetooth" class="bluetoothLink-input" @keyup.enter="gowork()" v-model="workid"
                ref="getIDInpot" />
        </div> -->
        <div v-if="showBluetooth" style="margin-top: 10px">
            当前工号为:{{ now_workerId }}
        </div>



        <!-- Current Selection Section -->
        <div v-else style="font-size: 14px; margin-top: 10px;">
            当前选择的工序/工人: {{ processName }}/{{ workerId }}
        </div>

        <!-- Dynamic Buttons -->
        <div class="bottom-section">
            <!-- Dynamic Buttons -->
            <div v-if="showButtons" class="dynamic-buttons"
                style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; padding: 15px 10px">
                <van-button v-for="(url, key) in processData" :key="key" type="primary" class="process-button"
                    @click="handleButtonClick(url)"
                    style="flex: 1 0 calc(25% - 10px); margin-left: 10px;margin-top: 10px;max-width: calc(25% - 10px)">
                    {{ key }}
                </van-button>
            </div>
        </div>
        <!-- Scanning Input Section -->
        <div v-if="showScanningInput" style="margin-top: 20px;">
            <input id="scanDetailInput" class="scan-detail-input" placeholder="请扫描明细码" ref="scanInput"
                @keyup.enter="handleScanDetail(gck_number)" v-model="gck_number" />
        </div>

        <!-- Display Success Message -->
        <div v-if="successMsg" :style="{ marginTop: '20px', fontSize: '30px', color: isError ? 'red' : 'green' }">
            {{ successMsg }}
        </div>

        <!-- Bottom Buttons -->
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="primary" class="bottom-button" @click="reloads()">刷新</van-button>
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="print_again()">再次打印</van-button>
            <van-button type="primary" class="bottom-button" @click="openPieceDialog">计件明细</van-button>

            <!-- <van-button type="info" class="bottom-button-b" @click="goLink()">发送蓝牙地址</van-button> -->
        </div>
        <div style="height: 600px; overflow: auto;color: #000;" v-if="show_print">
            <div class="wh"
                :style="{ width: S_width + 'cm', height: 15 + 'cm', marginTop: S_top + 'cm', padding: '5px', display: flex }"
                v-for="(i, index) in washData" :key="index" style="page-break-inside: avoid;">
                <!-- 非城市素颜使用 -->
                <div style="display: flex;justify-content: center;">
                    <!-- 左侧数据 -->
                    <div style="width: 5cm; height: 8cm;position: relative; text-align: left;" id="popupPrint">
                        <div style="font-size: 13px;margin: 3px 0;padding-left:0px;padding-bottom: 15px;">
                            <span
                                style="font-size: 13px;display:inline-block;width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.print_time }}</span>
                        </div>
                        <!-- <div style="font-size: 16px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                货号:{{ (i.name) }}</span>
                        </div>
                        <div style="margin: 3px 0;padding-left:0px;" :style="{ fontSize: '16px' }">
                            <span :style="{ fontSize: '16px' }"
                                style="display: inline-block; width: auto; vertical-align: top; overflow: visible; white-space: nowrap;font-weight: bold;">
                                颜色:{{ (i.rd_color) }}【{{ i.channel }}】</span>
                        </div>
                        <div style="font-size: 24px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="display:inline-block;font-size: 24px;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                宽:{{ (i.cpcm) }}</span>
                        </div>
                        <div style="font-size: 24px!important;margin: 3px 0;padding-left:0px;">
                            <span
                                style="display:inline-block;font-size: 24px;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                高:{{ (i.cpgd) }}</span>
                        </div>
                        <div style="font-size: 20px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 20px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                款式:{{ (i.cpks) }}</span>
                        </div> -->

                        <!-- <div style="font-size: 14px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 14px;display:inline-block;width: 65%;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                备注:{{ i.mx_remark[0] }}</span>
                        </div>
                        <div style="font-size: 14px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 14px;display:inline-block;width: 65%;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.mx_remark[1] || '&nbsp;' }}</span>
                        </div> -->
                        <div class="remark">
                            备注：{{ i.real_remark || '\u00A0' }}
                        </div>
                        <div style="font-size: 16px;margin: 3px 0;padding-left:0px;" v-if="i.enterprises_tech === '定型'">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                定型:{{ (i.enterprises_tech ? "高温定型" : "") }}</span>
                        </div>
                        <!-- <div style="font-size: 16px;margin: 3px 0;padding-left:0px;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.order_time }}【{{ i.goods_count }}】</span>
                        </div> -->
                        <!-- qrcode去生成 -->
                        <!-- <Barcode :JsBarcodeData="JsBarcodeConfigData"
                            style="width: 150px; height: 100px; margin: 0; padding-left: 15px;" /> -->
                        <div style="text-align: left;margin: 3px 0;padding-right: 0px;">
                            <img :src="i.qrCodeData" alt="QR Code" style="width: 80px;height: 80px">
                        </div>
                        <div style="font-size: 16px;margin: 0px 0;padding-left:0px;text-align: left;">
                            <span
                                style="font-size: 16px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                {{ i.gck_number }}</span>
                        </div>
                        <div style="font-size: 25px;margin: 0px 0;padding-left: 0px;margin-bottom: 20px;">
                            <span
                                style="font-size: 25px;display:inline-block;width: 65%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;vertical-align:top;font-weight: bold;">
                                [{{ i.number_count }}]</span>
                        </div>

                    </div>

                </div>


            </div>
        </div>
        <van-dialog v-model="pieceDialogVisible" title="计件明细" :show-confirm-button="false"
            :close-on-click-overlay="false" class="piece-dialog">
            <div class="piece-wrap">
                <!-- 顶部汇总 -->
                <div class="piece-top">
                    <div>总金额：{{ totalWages }}</div>
                    <div>总用料：{{ totalNums }}</div>
                </div>

                <!-- 日期筛选 -->
                <div class="piece-filters">
                    <input type="date" v-model="queryStart" class="piece-input" />
                    <input type="date" v-model="queryEnd" class="piece-input" />
                    <van-button size="small" type="primary" @click="searchPiece">查询</van-button>
                </div>

                <!-- 工人按钮 -->
                <div class="piece-workers">
                    <van-button v-for="w in workerButtons" :key="w.number" size="small"
                        :type="selectedGonghao === w.number ? 'primary' : 'default'" @click="selectWorker(w.number)">
                        {{ w.name }}
                    </van-button>
                </div>

                <!-- 表格 -->
                <div class="piece-table-wrap">
                    <table class="piece-table">
                        <thead>
                            <tr>
                                <th>明细码</th>
                                <th>工序</th>
                                <th>工价</th>
                                <th>用料</th>
                                <th>金额</th>
                                <th>时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in pieceRows" :key="idx">
                                <td>{{ row.number }}</td>
                                <td>{{ row.gongyi }}</td>
                                <td>{{ row.price }}</td>
                                <td>{{ nonull(row.nums) }}</td>
                                <td>{{ nonull(row.wages) }}</td>
                                <td>{{ row.time }}</td>
                            </tr>
                            <tr v-if="!pieceRows.length">
                                <td colspan="6" style="text-align:center;">暂无数据</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 分页 -->
                <div class="piece-pagination">
                    <van-button size="small" :disabled="pageInfo.current_page <= 1"
                        @click="changePage(pageInfo.current_page - 1)">上一页</van-button>
                    <span>第 {{ pageInfo.current_page }} / {{ pageInfo.last_page }} 页（共 {{ pageInfo.total }} 条）</span>
                    <van-button size="small" :disabled="pageInfo.current_page >= pageInfo.last_page"
                        @click="changePage(pageInfo.current_page + 1)">下一页</van-button>
                </div>

                <div style="text-align:right; margin-top:10px;">
                    <van-button type="danger" @click="pieceDialogVisible = false">关闭</van-button>
                </div>
            </div>
        </van-dialog>
        <van-dialog v-model="assistantDialogVisible" title="添加副手" :show-confirm-button="false"
            :close-on-click-overlay="true" class="assistant-dialog">
            <div class="assistant-wrap">
                <div class="assistant-info">
                    <div>当前主工号：<span>{{ mainWorkerId || '-' }}</span></div>
                    <div>当前副手：<span>{{ selectedAssistantNumber || '未选择' }}</span></div>
                </div>

                <div class="assistant-grid">
                    <div v-for="w in assistantWorkers" :key="w.number" class="assistant-card"
                        :class="{ active: selectedAssistantNumber === w.number }" @click="chooseAssistant(w)">
                        <div class="name">{{ w.name || w.number }}</div>
                        <div class="num">{{ w.number }}</div>
                    </div>
                </div>

                <div class="assistant-footer">
                    <van-button size="small" plain type="default" @click="assistantDialogVisible = false">
                        关闭
                    </van-button>
                </div>
            </div>
        </van-dialog>




    </div>


</template>

<script>
import $ from "jquery";
import axios from 'axios';
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import html2canvas from 'html2canvas';
import moment from 'moment';
import Barcode from '@/components/Barcode';
import QRCode from 'qrcode-generator';
import { Html5Qrcode } from "html5-qrcode";

export default {
    name: "bluetoothLink",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            username: "",
            lasttime: '',
            processData: {}, // 动态生成的工序数据
            workid: "", // 工号
            processName: "", // 工序名称（从 URL 中解析）
            workerId: "", // 工人 ID
            showBluetooth: true, // 是否显示 Bluetooth 输入框
            showButtons: true, // 是否显示动态按钮
            showScanningInput: false, // 是否显示扫描明细码输入框
            successMsg: "", // 用于展示请求成功后的消息
            show_print: false,
            JsBarcodeConfigData: {
                text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
                lineColor: "#000000", //二维码颜色
                background: "#fff", //二维码背景色
                //width: this.widthStyleObj, 
                bottomtext: '',
            },
            washData: [],
            gck_number: '',
            now_workerId: '',
            audio: new Audio(require("@/assets/ww.mp3")),
            isError: false,
            print_gck: '',
            showBluetooth: false, // 保留你的原变量
            showScanner: false,
            html5QrCode: null,

            cameras: [],
            currentCameraIndex: 0,
            currentCameraLabel: "",
            scanning: false,


            pieceDialogVisible: false,
            workerButtons: [], // [{name, number}]
            selectedGonghao: "",
            queryStart: "",
            queryEnd: "",
            pieceRows: [],
            totalWages: "0.00",
            totalNums: "0.00",
            pageInfo: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0
            },
            assistantDialogVisible: false,
            assistantWorkers: [],       // 副手列表 [{name, number}]
            mainWorkerId: "",           // 主工号（000）
            selectedAssistantNumber: "" // 当前已选副手工号
        };
    },
    components: {
        Barcode
    },
    mounted() {
        this.workid = JSON.parse(window.localStorage.getItem("userinfo"));
        window.receiveDataFromAndroid = this.receiveDataFromAndroid;
        window.receiveDataFromAndroids = this.receiveDataFromAndroids;
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        // setTimeout(() => {
        //     this.focus();
        // }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
        this.gowork();

    },
    methods: {
        focus() {
            this.$refs.getIDInpot.focus();
        },
        gowork() {
            this.now_workerId = this.workid;
            this.get("/processFindAndroid", { number: this.workid }).then(
                (res) => {
                    if (res.data != "") {

                        // 调用解析方法，保证逻辑与安卓一致
                        this.parseProcessData(JSON.stringify(res.data));
                    } else {
                        // 提示用户检查工号
                        this.showToast('请检查工号是否有误！');
                    }

                }
            ).catch((error) => {
                // 捕获请求错误
                console.error('请求失败:', error);
            });;
        },
        parseProcessData(responseData) {
            try {
                const jsonObject = JSON.parse(responseData);
                const status = jsonObject.status;
                const msg = jsonObject.msg;
                if (status === 0) {
                    Toast(msg); // 显示提示信息
                    this.workid = ""; // 清空输入框
                    this.processData = {}; // 清空按钮数据
                    return;
                }
                const data = jsonObject.data;
                this.processData = {}; // 清空之前的数据
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {
                        const process = data[key];
                        const url = process.url;
                        this.processData[key] = url; // 存储动态按钮数据
                    }
                }
            } catch (e) {
                console.error("数据解析失败", e);
            }
        },
        // 动态按钮点击事件
        async handleButtonClick(url) {
            if (url.startsWith("http://")) {
                url = url.replace("http://", "http://");
            }
            this.urlsend = url;
            // 确保 workerId 初始化
            if (!this.workerId) {
                this.workerId = this.workid;
            }
            // 同步 people 参数
            this.urlsend = this.replacePeopleInUrl(this.urlsend, this.workerId);
            // 从 URL 中解析工序名称（假设 URL 格式为：...process=工序名）
            const processMatch = url.match(/process=([^&]*)/);
            this.processName = processMatch ? processMatch[1] : "未知工序";
            if (!this.workerId) {
                this.workerId = this.workid; // 将工号赋值给 workerId
            }
            // 隐藏 Bluetooth 和按钮，显示扫描明细框
            this.showBluetooth = false;
            this.showButtons = false;
            this.showScanningInput = true;
            Android.sendghandgr(this.processName + "," + this.workerId);
            this.focusInput("scanInput");
            console.log("当前选工序：", this.processName);
            console.log("当前选工人：", this.workerId);
        },
        async handleScanDetail(ids) {
            this.print_gck = "";
            this.print_gck = ids;
            this.isError = false;
            const completeUrl = `${this.urlsend}${ids}`; // 拼接 URL
            try {
                const res = await axios.get(completeUrl);
                console.log(res);
                if (res.data && res.data.data && res.data.data.data && (res.data.data.data.status == 1 || res.data.data.data.status == "OK")) {
                    if (this.processName == "包装") {
                        this.successMsg = res.data.msg;
                        const result = await this.getwash(ids);
                        if (result === null) {
                            return;
                        }
                        // console.log("aaaa")
                        this.dayin();
                    } else {
                        this.successMsg = res.data.msg;
                        this.gck_number = ""

                    }

                    this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                } else {
                    if (this.processName == "包装") {

                        const result = await this.getwash(ids);
                        if (result === null) {
                            this.successMsg = "获取数据失败";
                            return;
                        }
                        this.successMsg = "打印成功";
                        // console.log("aaaa")
                        this.dayin();
                        this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                    } else {
                        // 显示错误提示
                        this.isError = true; // 新增一个标志变量，表示当前是否为错误情况
                        this.audio.play();
                        this.gck_number = ""
                        this.successMsg = res.data.msg;
                        this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                    }

                }
            } catch (error) {
                // 捕获请求错误
                this.audio.play();
                this.gck_number = ""
                this.focusInput("scanInput"); // 再次聚焦到详细码输入框
                console.error("请求失败：", error);
                Toast("请求异常，请稍后重试！");
            }
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        async dayin() {
            this.show_print = true;
            await this.$nextTick();
            // 等待html2canvas渲染完成
            const canvas = await html2canvas(document.querySelector("#popupPrint"));

            var imageBase64 = canvas.toDataURL(); // 将imageData作为参数传递给callAndroid()方法
            imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
            console.log(imageBase64);
            this.gck_number = ""
            // 调用callAndroid
            this.callAndroid(imageBase64);
        },
        // dayin() {
        //     this.JsBarcodeConfigData.text = "123123";
        //     this.JsBarcodeConfigData.bottomtext = "123123";
        //     this.show_print = true;

        //     html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
        //         //document.body.appendChild(canvas);
        //         var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
        //         var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
        //         console.log(imageBase64);
        //         this.callAndroid(imageBase64);
        //     });
        // },
        callAndroid(imageBase64) {
            var BASE64_ENCODED_IMAGE_DATA = imageBase64;
            var imageData = BASE64_ENCODED_IMAGE_DATA;
            console.log(imageData);
            this.show_print = false;
            Android.receiveImage(imageData);
            alert("printPreview");
        },
        focusInput(refName) {
            this.$nextTick(() => {
                const input = this.$refs[refName];
                if (input) {
                    input.focus();
                }
            });
        },
        // async receiveDataFromAndroid(data) {
        //     this.now_workerId = "";
        //     if (data) {
        //         this.now_workerId = data;
        //         this.workerId = data;
        //         this.get("/processFindAndroid", { number: data }).then(
        //             (res) => {
        //                 if (res.data != "") {
        //                     // 调用解析方法，保证逻辑与安卓一致
        //                     this.parseProcessData(JSON.stringify(res.data));
        //                 } else {
        //                     // 提示用户检查工号
        //                     this.showToast('请检查工号是否有误！');
        //                 }

        //             }
        //         ).catch((error) => {
        //             // 捕获请求错误
        //             console.error('请求失败:', error);
        //         });;
        //     }
        // },
        receiveDataFromAndroids(data) {
            if (data) {
                if (this.showBluetooth) {
                    this.workid = data;
                    this.gowork()
                } else {
                    this.gck_number = data;
                    this.handleScanDetail(data);
                }
            }
        },
        async getwash(val) {
            // 使用 fetch 发起 GET 请求
            try {
                this.time = '';
                let current_time = this.getCurrentDateTime();
                this.washData = [];
                const url = `https://admintm.runfeinet.com/admin/orderMxDyAll?id=${val}`;
                const responseData = await fetch(url);
                const wash = await responseData.json();
                if (wash.status == 1) {
                    wash.data.forEach((item, index) => {
                        const washData = {};
                        washData.flag = (item.order_number.indexOf('ylst') && item.order_number.indexOf('aml')) === -1 ? true : false;
                        washData.jt_xh = item.sis['型号'] ? item.sis['型号'] : (this.xh ? this.noramal(xh) : (item.ppxh ? this.noramal(item.ppxh) : this.noramal(item.xh)))
                        if (item.goods_count == 1) {
                            // 检查 item.gck_number 是否包含 "-"
                            if (!item.gck_number.includes('-')) {
                                // 如果不包含 "-", 则将其修改为 item.gck_number + '-'
                                this.JsBarcodeConfigData.text = item.gck_number + '-1';
                                this.JsBarcodeConfigData.bottomtext = item.gck_number + '-1';

                            } else {
                                this.JsBarcodeConfigData.text = item.gck_number;
                                this.JsBarcodeConfigData.bottomtext = item.gck_number;
                            }
                        } else {
                            this.JsBarcodeConfigData.text = item.gck_number;
                            this.JsBarcodeConfigData.bottomtext = item.gck_number;
                        }
                        const qr = QRCode(0, 'H');
                        qr.addData(this.JsBarcodeConfigData.text);
                        qr.make();
                        const imageDataURL = qr.createDataURL(10, 0);
                        washData.qrCodeData = imageDataURL;
                        washData.print_time = current_time;
                        washData.goods_id = item.goods_id;
                        washData.enterprises_tech = item.enterprises_tech;
                        washData.rd_color = item.rd_color;
                        washData.channel = item.channel ? item.channel[0] : '';
                        washData.ppxh = item.ppxh;
                        washData.dyyz = item.dyyz;
                        washData.dymd = item.dymd;
                        washData.goods = item.goods_new;
                        washData.warehouse = item.warehouse;
                        washData.address = item.address;
                        washData.color = item.color;
                        // 假设 item.mx_remark 是字符串
                        washData.mx_remark = [];
                        let remark = item.mx_remark || ""; // 确保 remark 不为 null 或 undefined
                        // 分割字符串
                        washData.mx_remark[0] = remark.substring(0, 6); // 取前6个字符
                        washData.mx_remark[1] = remark.substring(6);   // 取剩余的字符
                        washData.real_remark = item.mx_remark || "";
                        washData.wash = item.wash;
                        washData.webname = item.webname;
                        washData.order_time = this.datetimes(item.order_time);
                        washData.logo = item.logo;
                        washData.belong = item.belong;
                        washData.goods_id = item.goods_id;
                        washData.people = item.people;
                        washData.ppbz = item.ppbz;
                        washData.hp = item.hp;
                        washData.xlh = item.xlh;
                        washData.goods_count = item.goods_count;
                        washData.kd_status = item.kd_status;
                        // washData.name = item.name;
                        if (item.name.indexOf('-') !== -1) {
                            washData.name = item.name.split('-')[0];
                        } else {
                            washData.name = item.name;
                        }
                        washData.fx = item.fx;
                        washData.ks = item.ks;
                        washData.mst = item.mst;
                        washData.mk = item.mk;
                        washData.xh = item.xh;
                        washData.gg = item.gg;
                        washData.lg = item.lg;
                        washData.cm = item.cm;
                        // 检查 item.count 是否为 1
                        if (item.goods_count == 1) {
                            // 检查 item.gck_number 是否包含 "-"
                            if (!item.gck_number.includes('-')) {
                                // 如果不包含 "-", 则将其修改为 item.gck_number + '-'
                                washData.gck_number = item.gck_number + '-1';
                            } else {
                                washData.gck_number = item.gck_number;
                            }
                        } else {
                            washData.gck_number = item.gck_number;
                        }
                        washData.fc = item.fc;
                        washData.order_number = item.order_number;
                        washData.dm = item.dm;
                        washData.khfx = item.sis.开合方向;
                        washData.cpks = item.sis.成品款式;
                        washData.chkd = item.sis.宽度;
                        washData.cpcm = item.sis.宽度;
                        washData.cpgd = item.sis.高度;
                        washData.fjmc = item.sis.房间名称;
                        washData.count = item.count;
                        washData.number_count = item.number_count;
                        this.washData.push(washData);
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: '打印接口错误！',
                    })
                    this.gck_number = "";
                    this.print_gck = "";
                }
            } catch (error) {
                console.log(error)
                Toast("打印请求异常，请稍后重试！");
                this.print_gck = "";
                this.gck_number = "";
                return null; // 或者返回其他默认值
            }
        },
        getCurrentDateTime() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        noramal(value) {
            if (value == null || value == undefined) {
                return ''
            } else {
                return value
            }
        },
        datetimes(times) {
            // 原始日期字符串
            const dateTime = times;

            // 使用 split 方法分割日期和时间
            const datePart = dateTime.split(' ')[0]; // "2024-11-05"

            // 将日期部分再分割为年、月、日
            const dateComponents = datePart.split('-'); // ["2024", "11", "05"]

            // 提取需要的部分，拼接成目标字符串
            const result = dateComponents[0].slice(2) + dateComponents[1] + dateComponents[2]; // "241105"
            return result
        },
        scanQRCode() {
            Android.scarn();
        },
        onClickLeft() {
            localStorage.removeItem("checked_auto");
            localStorage.removeItem("userinfo");
            this.$router.push("/");
        },
        async print_again() {
            if (this.processName == "包装") {
                if (!this.print_gck) {
                    Toast("请先扫描明细码");
                }
                const result = await this.getwash(this.print_gck);
                if (result === null) {
                    return;
                }
                this.dayin();
            } else {
                Toast("请选择包装工序后打印");
            }
            this.focusInput("scanInput"); // 再次聚焦到详细码输入框
        },
        reloads() {
            window.location.reload();
        },
        // 你按钮里绑定的是这个方法
        async qrcode_scarcn() {
            try {
                this.showScanner = true;
                await this.$nextTick();

                // 防止重复初始化
                if (!this.html5QrCode) {
                    this.html5QrCode = new Html5Qrcode("qr-reader");
                }

                // 获取摄像头列表
                this.cameras = await Html5Qrcode.getCameras();
                if (!this.cameras || this.cameras.length === 0) {
                    alert("未检测到摄像头设备");
                    this.showScanner = false;
                    return;
                }

                // 优先找到后置
                const backIndex = this.cameras.findIndex((d) =>
                    /back|rear|environment|后置|背面/gi.test(d.label || "")
                );
                this.currentCameraIndex = backIndex >= 0 ? backIndex : 0;

                // 启动扫码：先尝试后置 facingMode，失败再用 cameraId
                await this.startScannerWithFallback();
            } catch (err) {
                console.error("启动扫码失败:", err);
                alert("启动扫码失败，请检查摄像头权限（需HTTPS或localhost）");
                this.showScanner = false;
            }
        },

        async startScannerWithFallback() {
            if (!this.html5QrCode) return;

            const config = {
                fps: 10,
                qrbox: { width: 250, height: 250 },
                aspectRatio: 1.0,
            };

            // 成功回调
            const onSuccess = async (decodedText) => {
                console.log("扫码成功:", decodedText);
                // 这里可以替换成你的业务逻辑
                // alert("扫码结果：" + decodedText);
                this.handleScanDetail(decodedText)

                // 扫到后自动关闭（如需连续扫码可注释）
                await this.stopScanner();
            };

            // 失败回调（扫码过程中会频繁触发，通常不提示）
            const onError = () => { };

            try {
                // 1) 先尝试后置摄像头
                await this.html5QrCode.start(
                    { facingMode: "environment" },
                    config,
                    onSuccess,
                    onError
                );
                this.scanning = true;
                this.currentCameraLabel = "后置（facingMode）";
            } catch (e1) {
                console.warn("facingMode后置失败，尝试cameraId:", e1);

                // 2) 再用枚举到的 cameraId
                const cam = this.cameras[this.currentCameraIndex];
                if (!cam) throw e1;

                await this.html5QrCode.start(cam.id, config, onSuccess, onError);
                this.scanning = true;
                this.currentCameraLabel = cam.label || `Camera ${this.currentCameraIndex + 1}`;
            }
        },

        async switchCamera() {
            if (!this.html5QrCode || this.cameras.length < 2) return;

            try {
                if (this.scanning) {
                    await this.html5QrCode.stop();
                    this.scanning = false;
                }

                this.currentCameraIndex =
                    (this.currentCameraIndex + 1) % this.cameras.length;

                const cam = this.cameras[this.currentCameraIndex];

                await this.html5QrCode.start(
                    cam.id,
                    {
                        fps: 10,
                        qrbox: { width: 250, height: 250 },
                        aspectRatio: 1.0,
                    },
                    async (decodedText) => {
                        console.log("扫码成功:", decodedText);
                        // alert("扫码结果：" + decodedText);
                        this.handleScanDetail(decodedText)

                        await this.stopScanner();
                    },
                    () => { }
                );

                this.scanning = true;
                this.currentCameraLabel = cam.label || `Camera ${this.currentCameraIndex + 1}`;
            } catch (err) {
                console.error("切换摄像头失败:", err);
                alert("切换摄像头失败");
            }
        },

        async stopScanner() {
            try {
                if (this.html5QrCode) {
                    // 只有在扫描中才stop
                    if (this.scanning) {
                        await this.html5QrCode.stop();
                        this.scanning = false;
                    }
                    await this.html5QrCode.clear();
                    this.html5QrCode = null;
                }
            } catch (err) {
                console.warn("关闭扫码异常:", err);
            } finally {
                this.showScanner = false;
                this.currentCameraLabel = "";
            }
        },
        openPieceDialog() {
            this.queryStart = "";
            this.queryEnd = "";
            this.pieceDialogVisible = true;

            // 可能是： "A001,A002,A003"
            const raw = this.workerId || this.workid || this.now_workerId || "";
            const ids = this.parseWorkerIds(raw);

            // 展示多个按钮
            this.workerButtons = ids.map(id => ({
                name: id,      // 如果你有姓名映射，可改成真实姓名
                number: id
            }));

            // 默认取第一个访问
            this.selectedGonghao = ids.length ? ids[0] : "";

            if (this.selectedGonghao) {
                this.fetchWorkerHistory(this.selectedGonghao, 1);
            } else {
                this.pieceRows = [];
                this.totalWages = "0.00";
                this.totalNums = "0.00";
                this.pageInfo = { current_page: 1, per_page: 10, total: 0, last_page: 1 };
            }
        },
        searchPiece() {
            if (!this.selectedGonghao) return Toast("请先选择工人");
            this.fetchWorkerHistory(this.selectedGonghao, 1);
        },
        selectWorker(gonghao) {
            this.selectedGonghao = gonghao;
            this.fetchWorkerHistory(gonghao, 1);
        },
        changePage(page) {
            if (!this.selectedGonghao) return;
            this.fetchWorkerHistory(this.selectedGonghao, page);
        },
        getTodayRange() {
            const d = new Date();
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            return {
                start: `${y}-${m}-${day}`,
                end: `${y}-${m}-${day}`
            };
        },

        async fetchWorkerHistory(gonghao, page) {
            page = page || 1;
            try {
                const url = window.localStorage.getItem("pdaBASEURL") || "";
                const baseUrl = url.replace("/api", "");
                const api = baseUrl + "/admin/workerHistory";

                // 关键：queryStart/queryEnd 为空时，用当天起止时间
                const todayRange = this.getTodayRange();
                if (!this.queryStart && !this.queryEnd) {
                    this.queryStart = todayRange.start
                    this.queryEnd = todayRange.end;
                }

                const res = await this.get(api, {
                    gonghao: gonghao,
                    start: this.queryStart,
                    end: this.queryEnd,
                    page: page
                });

                var r = res && res.data ? res.data : (res || {});
                var block = {};
                var ddt = {};
                var list = [];
                if (r.data && r.data.length > 0) {
                    block = r.data[0] || {};
                    ddt = block.data || {};
                    list = ddt.data || [];
                }

                this.pieceRows = list;
                this.totalWages = Number(block.total_wages || 0).toFixed(2);
                this.totalNums = Number(block.total_nums || 0).toFixed(2);

                this.pageInfo.current_page = Number(ddt.current_page || page);
                this.pageInfo.per_page = Number(ddt.per_page || 10);
                this.pageInfo.total = Number(ddt.total || 0);
                this.pageInfo.last_page = Number(ddt.last_page || 1);

            } catch (e) {
                console.error(e);
                Toast("获取计件明细失败");
            }
        },
        nonull(v) {
            return v === null || v === undefined || v === "" ? "" : v;
        },
        parseWorkerIds(workerStr) {
            if (!workerStr) return [];
            return String(workerStr)
                .split(",")
                .map(s => s.trim())
                .filter(Boolean);
        },
        async onClickRight() {
            if (this.showScanningInput == false) {
                Toast("请先选择工序");
                return;
            }

            // 解析主工号和已选副手
            const workerArr = (this.workerId || "").split(",");
            this.mainWorkerId = workerArr[0] || this.workid || "";
            this.selectedAssistantNumber = workerArr[1] || "";

            try {
                const res = await this.get(this.APIOBJ.processUserList, {
                    process: this.processName,
                });

                if (res.data.status == 1) {

                    const Rdata = res.data.data.data || [];
                    // 你说 Rdata 里每项有 number（数组很多参数里取 number）
                    // 这里兼容 name/username 字段
                    this.assistantWorkers = Rdata.map(item => ({
                        number: item.number,
                        name: item.name || item.username || item.number
                    })).filter(x => x.number);

                    this.assistantDialogVisible = true;
                } else {
                    Toast(res.data.msg || "获取工人失败");
                }
            } catch (e) {
                console.error(e);
                Toast("获取工人失败");
            }
        },
        chooseAssistant(worker) {
            // 主工号优先用 mainWorkerId，没有就用当前 workerId 的第一个
            const main = this.mainWorkerId || (this.workerId || "").split(",")[0] || this.workid || "";
            if (!main) {
                Toast("主工号为空");
                return;
            }

            // 防止自己选自己（可选）
            if (worker.number === main) {
                Toast("副手不能与主工号相同");
                return;
            }

            // 替换副手
            this.selectedAssistantNumber = worker.number;
            this.workerId = `${main},${worker.number}`;

            // 同步替换 urlsend 的 people 参数
            this.urlsend = this.replacePeopleInUrl(this.urlsend, this.workerId);

            this.assistantDialogVisible = false;
            Toast(`已选择副手：${worker.name || worker.number}`);
        },
        replacePeopleInUrl(url, peopleValue) {
            if (!url) return url;
            const encodedPeople = encodeURIComponent(peopleValue);

            // 已有 people= 参数 -> 替换
            if (/([?&])people=([^&]*)/.test(url)) {
                return url.replace(/([?&])people=([^&]*)/, `$1people=${encodedPeople}`);
            }

            // 没有 people 参数 -> 追加
            const hasQuery = url.includes("?");
            return url + (hasQuery ? "&" : "?") + `people=${encodedPeople}`;
        },



    },
    beforeDestroy() { // Vue2
        this.stopScanner();
    },

};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.bluetooth {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 50px;
}

.bluetoothLink-input {
    height: 22px;
    width: 4rem;
    width: 70%;
}

.bottom-button-b {
    width: auto;
}

.scanner-mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.scanner-box {
    background: #fff;
    padding: 16px;
    border-radius: 12px;
    text-align: center;
}

.scan-btn-group {
    display: flex;
    justify-content: center;
    /* 居中 */
    align-items: center;
    gap: 12px;
    /* 两按钮间距 */
    margin-bottom: 12px;
    flex-wrap: wrap;
    /* 小屏自动换行 */
}

.scan-button {
    font-size: 16px;
    padding: 10px 20px;
    background: linear-gradient(90deg, #2196F3, #42A5F5);
    color: white;
    border: none;
    border-radius: 25px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
}

.scan-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.piece-dialog {
    width: 95% !important;
    max-width: 1000px;
}

.piece-wrap {
    padding: 10px;
}

.piece-top {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-bottom: 10px;
}

.piece-filters {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
}

.piece-input {
    border: 1px solid #ddd;
    padding: 4px 6px;
    border-radius: 4px;
}

.piece-workers {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.piece-table-wrap {
    max-height: 320px;
    overflow: auto;
    border: 1px solid #eee;
}

.piece-table {
    width: 100%;
    border-collapse: collapse;
}

.piece-table th,
.piece-table td {
    border: 1px solid #eee;
    padding: 6px;
    font-size: 12px;
}

.piece-table thead th {
    position: sticky;
    top: 0;
    background: #fafafa;
    z-index: 1;
}

.piece-pagination {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.assistant-dialog {
    width: 92% !important;
    max-width: 760px;
}

.assistant-wrap {
    padding: 12px;
}

.assistant-info {
    margin-bottom: 12px;
    font-size: 13px;
    color: #666;
    line-height: 1.9;

    span {
        color: #333;
        font-weight: 600;
    }
}

.assistant-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    gap: 10px;
    max-height: 320px;
    overflow-y: auto;
    padding-right: 2px;
}

.assistant-card {
    background: #f5f7fb;
    border: 1px solid #e8ecf3;
    border-radius: 10px;
    padding: 10px 8px;
    text-align: center;
    cursor: pointer;
    transition: all .2s ease;
    user-select: none;

    .name {
        font-size: 14px;
        font-weight: 600;
        color: #2f3a4a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .num {
        margin-top: 4px;
        font-size: 12px;
        color: #8a94a6;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(38, 90, 180, 0.12);
        border-color: #b9ccf5;
    }

    &.active {
        background: linear-gradient(135deg, #3b82f6, #5aa2ff);
        border-color: #3b82f6;
        box-shadow: 0 6px 14px rgba(59, 130, 246, 0.28);

        .name,
        .num {
            color: #fff;
        }
    }
}

.assistant-footer {
    text-align: right;
    margin-top: 12px;
}

.remark {
    width: 80%;
    margin: 3px 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;

    /* 最多显示5行 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;

    overflow: hidden;
    text-overflow: ellipsis;

    /* 自动换行，长英文或连续字符也能换行 */
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-all;

    /* 非 WebKit 浏览器的备用限制 */
    max-height: 200px;
    /* 20px × 5行 */
}

.remark-title {
    margin-right: 2px;
}
</style>